<template>
	<div class="content">
		<div class="container">
			<img src="@/assets/footer/img-main-try-logo.png"
						srcset="@/assets/footer/img-main-try-logo@2x.png 2x,
	 				@/assets/footer/img-main-try-logo@3x.png 3x" class="center"/>
			<p v-html="l10.All_Footer_Title1">

			</p>
			<p  v-html="l10.All_Footer_Title1_Description1_Description1">

			</p>
			<div>
				<template v-if="this.$store.state.lang != 'cn' || this.$store.state.cnDownloadUrl == this.$store.state.cnStaticDownloadUrl">
					<div class="store-btn">
						<a :href="appStoreUrl" target="_blank"><img class="pc_appstore_btn" src="@/assets/footer/img-appstore-btn-blk.svg"></a>
					</div>
				</template>
				<template v-if="this.$store.state.lang == 'cn' && this.$store.state.cnDownloadUrl != ''">
					<div class="store-btn" @click="handleClickAndroidDownload">
						<img src="../../assets/home/img-android-download-btn-blk.svg">
					</div>
				</template>
				<template v-else>
					<div class="store-btn">
						<a :href="googlePlayUrl" target="_blank"><img class="pc_playstore_btn" src="@/assets/footer/img-googleplay-btn-blk.svg"></a>
					</div>				
				</template>
			</div>
		</div>
	</div>
</template>
<script>

export default {
	name: 'TryTodomathBottom',
	data () {
			const text = require('@/text/common/footer.js').default;
			const l10n = text[this.$store.state.lang]?text[this.$store.state.lang]:text['en'];
	    return {
				l10:l10n,
				appStoreUrl: this.$store.state.appStoreUrl,
				googlePlayUrl:this.$store.state.googlePlayUrl,
				cnDownloadUrl:this.$store.state.cnDownloadUrl
	    }
	},
	methods: {
		handleClickAndroidDownload() {
			this.$emit('click-cn-androiddownload')
		}
	}
}
</script>
<style  scoped>
.content{
	width:100%;
	overflow: hidden;
	background-image: url("../../assets/footer/img-main-try-bg.png");
	background-size:2400px auto;
	background-repeat: no-repeat;
	background-position: center;
	height:630px;
}

.container{
	margin: 0 auto;
	padding-top:100px;
	height: auto;
	min-height: 100px;
	width:1024px;
	display: flex;
	flex-direction: column;
	align-items: center;

}
.container>img{
	width: 227.2px;
  height: 172px;
  object-fit: contain;

}
.container>p:first-of-type{
	font-size: 56px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.57;
  letter-spacing: -2.2px;
  text-align: center;
  color: #41403e;
  margin-top:18px;
}
.container>p:last-of-type{
	font-size: 22px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.82;
  letter-spacing: -0.9px;
  text-align: center;
  color: #41403e;
  margin-bottom: 51px;
}
.store-btn{
	width: 210px;
	height: 64px;
	display: inline-block;
    cursor: pointer;
}
.store-btn ~ .store-btn{
	margin-left:20px;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/TryTodomathLaptop.vue